import { render, staticRenderFns } from "./ViewSsnControl.vue?vue&type=template&id=09450337&scoped=true"
import script from "./ViewSsnControl.vue?vue&type=script&lang=js"
export * from "./ViewSsnControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09450337",
  null
  
)

export default component.exports